module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "sp1"
  }), _vm._v(" "), _c('p', {
    staticClass: "Dedication-ded"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_5",
      "title": "5"
    }
  }, [_vm._v("Writing is my journey,")])])]), _vm._v(" "), _c('p', {
    staticClass: "Dedication-ded"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("It is how I make sense of the world.")])]), _vm._v(" "), _c('p', {
    staticClass: "Dedication-ded"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("These people I come to know in the books show me.")])]), _vm._v(" "), _c('p', {
    staticClass: "Dedication-ded"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("They speak to me. They lead me to my truth.")])]), _vm._v(" "), _c('p', {
    staticClass: "Dedication-ded"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("They give to me my sight.")])]), _vm._v(" "), _c('p', {
    staticClass: "Dedication-ded"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("So this is to Aoleyn,")])]), _vm._v(" "), _c('p', {
    staticClass: "Dedication-ded"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Who made me look at the world from a different angle")])]), _vm._v(" "), _c('p', {
    staticClass: "Dedication-ded"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("And in a different light.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69c5fffa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 69
// module chunks = 0